import { FormattedMessage } from 'react-intl'

import { IconExclamationTriangle } from '@gto/ui/assets'
import { Button } from '@gto/ui/button'
import { Typography } from '@gto/ui/typography'

export type EmailValidationErrorProps = {
  onRequestNewLink: () => void
  onBackToAccount: () => void
}

export const EmailValidationError = ({
  onRequestNewLink,
  onBackToAccount,
}: EmailValidationErrorProps) => {
  return (
    <div className="flex flex-col gap-8">
      <div className="flex items-center gap-4">
        <IconExclamationTriangle
          height={48}
          width={48}
        />
        <Typography variant="h3">
          <FormattedMessage id="user.settings.email.validation.error.title" />
        </Typography>
      </div>

      <Typography
        color="text.secondary"
        variant="body1"
      >
        <FormattedMessage id="user.settings.email.validation.error.description" />
      </Typography>

      <div className="flex flex-wrap gap-4">
        <Button
          className="max-w-[300px]"
          color="primary"
          size="large"
          variant="contained"
          onClick={onRequestNewLink}
        >
          <FormattedMessage id="user.settings.email.validation.error.requestNewLink" />
        </Button>
        <Button
          className="max-w-[220px]"
          color="secondary"
          size="large"
          variant="contained"
          onClick={onBackToAccount}
        >
          <FormattedMessage id="user.settings.accountManagement" />
        </Button>
      </div>
    </div>
  )
}
